import { MediaHelpers } from '@tldraw/tldraw'

export const getVideoSizeFromSrc = (src: string) => MediaHelpers.getVideoSizeFromSrc(src)
